/**
 * Referenz auf eine andere Ressource, wie sie das Backend liefert: je nach Serializer-Gruppe
 * als `{ id }`, als nackte Id oder als IRI (`/api/…/1`).
 */
export type MedicalRef = { id: number } | number | string | null | undefined;

/** Wandelt eine {@link MedicalRef} in die Id um. */
export function refId(ref: MedicalRef): number | null {
  if (ref === null || ref === undefined) return null;
  if (typeof ref === 'number') return ref;
  if (typeof ref === 'string') {
    const match = ref.match(/(\d+)\/?$/);
    return match ? Number(match[1]) : null;
  }
  return typeof ref.id === 'number' ? ref.id : null;
}
